import Chevron from 'components/Chevron';
import React from 'react';
import { extendClassName } from 'utils/common';

interface IBackButton {
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const BackButton = ({
  className,
  children,
  onClick = () => {},
  style,
}: IBackButton) => (
  <div
    className={extendClassName(
      'backButton vertical-margin-1em clickable',
      className,
    )}
    onClick={onClick}
  >
    <p className="large noMargin">
      <span className="bold" style={{ marginLeft: '-1em', ...style }}>
        <Chevron
          direction="left"
          style={{
            marginRight: '0.8em',
            verticalAlign: 'middle',
            display: 'inline',
            fontSize: '1em',
          }}
        />
        {children ?? 'Back'}
      </span>
    </p>

    <style jsx>
      {`
        .backButton {
          padding: 0.5em 0.5em 0.5em 1.25em;
        }
      `}
    </style>
  </div>
);

export default BackButton;
